var _path, _path2, _path3, _line, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Pdf50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f48fb1",
    d: "M13.5,25.5v18c0,1.657,1.343,3,3,3h23c1.657,0,3-1.343,3-3v-21l-13-13h-13c-1.657,0-3,1.343-3,3v5 V25.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M38.5,28.5v-10h-10c-1.657,0-3-1.343-3-3v-10h-13c-1.657,0-3,1.343-3,3v5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M9.5,21.5v18c0,1.657,1.343,3,3,3h23c1.657,0,3-1.343,3-3v-3"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 38.5,
    x2: 25.5,
    y1: 18.5,
    y2: 5.5,
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18193f",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M18.561,37.561C18.239,37.822,17.884,38,17.5,38 s-0.768-0.146-1.061-0.439C16.146,37.268,16,36.884,16,36.5s0.137-0.778,0.439-1.061C17.969,34.01,23.354,31,30.5,31 c0.828,0,1.5,0.672,1.5,1.5S31.328,34,30.5,34C26,34,21,27.365,21,23.5c0-0.828,0.672-1.5,1.5-1.5s1.5,0.672,1.5,1.5 C24,30,19.969,36.417,18.561,37.561z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Pdf50);
export default __webpack_public_path__ + "static/media/icons8-pdf-50.8b7d7b41aaf3cc943bb18829d0b7dd7b.svg";
export { ForwardRef as ReactComponent };